import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateProfileService } from 'app/modules/update-profile/services/update-profile.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss'],
  providers: [UpdateProfileService],
  encapsulation: ViewEncapsulation.None
})
export class MyAccountComponent implements OnInit {
  public showLoader: boolean = false;
  public consumerDetail: any;
  public resGetVcipStatus: any;
  public isVcipComplete: boolean = false;
  public skipVcipStatus: boolean = false;
  public modalReference: any;
  public xplorerVcipMessage: string = '';
  public xplorerVcipTitle: string = '';
  @ViewChild("vcipModalNewUser") vcipModalNewUser: TemplateRef<any>;


  public menuItems = [
    {
      'iconSrc': 'fingerprint.png',
      'icon': 'fingerprint.png',
      'iconW': 'fingerprint-white.png',
      'title': 'Reset Password',
      'url': 'security-setting',
    },
    {
      'iconSrc': 'credit.png',
      'icon': 'credit.png',
      'iconW': 'credit-white.png',
      'title': 'My Card',
      'url': 'my-card',
    },
    {
      'iconSrc': 'bank.png',
      'icon': 'bank.png',
      'iconW': 'bank-white.png',
      'title': 'My Bank Account',
      'url': 'list-bank-account',
    },
    {
      'iconSrc': 'man.png',
      'icon': 'man.png',
      'iconW': 'man-white.png',
      'title': 'Beneficiary',
      'url': 'list-beneficiary',
    },
    {
      'iconSrc': 'carts.png',
      'icon': 'carts.png',
      'iconW': 'carts-white.png',
      'title': 'My Orders',
      'url': 'order-list',
    },
    {
      'iconSrc': 'address.png',
      'icon': 'address.png',
      'iconW': 'address-white.png',
      'title': 'My Address',
      'url': 'list-address',
    },
    {
      'iconSrc': 'ticket.png',
      'icon': 'ticket.png',
      'iconW': 'ticket-white.png',
      'title': 'My Tickets',
      'url': 'listServiceRequest',
    },
    {
      'iconSrc': 'twins.png',
      'icon': 'twins.png',
      'iconW': 'twins-white.png',
      'title': 'My Relation',
      'url': 'list-relationship',
    },
    {
      'iconSrc': 'my-policy.png',
      'icon': 'my-policy.png',
      'iconW': 'my-policy-white.png',
      'title': 'My Policy',
      'url': 'insurance-list',
    },
  ];

  constructor(
    public router: Router,
    public updateProfileService: UpdateProfileService,
    public toast: ToastrService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    this.getProfileList();
  }

  goToEditProfile() {
    this.router.navigate(['/update-profile']);
  }

  getProfileList() {
    this.showLoader = true;
    this.updateProfileService.getProfileListAll().subscribe(resp => {
      this.consumerDetail = resp.body;
      this.isVcipComplete = this.consumerDetail?.vcipKyc;
      console.log("this.isVcipComplete >>", this.isVcipComplete);
      if (this.consumerDetail?.paxResponse?.consumer?.vcipSkipAllowed) {
        this.isVcipComplete = true;
      } else if (this.consumerDetail?.paxResponse?.consumer?.offlineonboarding == '1') {
        this.isVcipComplete = true;
      }
      this.getVCIPStatus();
    }, error => {
      this.showLoader = false;
      this.toast.error(error.error.message);
    });
  }

  async getVCIPStatus() {
    this.updateProfileService.getVCIPStaus().subscribe((resp => {
      this.showLoader = false;
      this.resGetVcipStatus = resp.body;
      if (this.resGetVcipStatus.vcipStatus == 'ACCEPTED') {
        this.isVcipComplete = true;
      }
    }), error => {
      this.showLoader = false;
      this.toast.error(error.error.message);
    });
    return true;
  }

  proceedToNextPage(pageUrl) {
    this.router.navigate([pageUrl]);
  }

  openModalForVCIPNewUser() {
    this.setXplorerVcipContent();
    this.modalReference = this.modalService.open(this.vcipModalNewUser, {
      centered: true,
      size: 'md',
    });
  }

  setXplorerVcipContent() {
    const status = (this.resGetVcipStatus?.vcipStatus || '').toUpperCase();
    this.xplorerVcipTitle = '';
    this.xplorerVcipMessage = this.resGetVcipStatus?.message || '';
    if (status == 'NOT_INITIATED' || status == 'INITIATED' || status == 'IN_PROGRESS' || !status) {
      this.xplorerVcipMessage = ' A quick video call is needed to verify your identity. It takes just a few minutes. Please keep your original PAN card ready.';
      this.xplorerVcipTitle = 'Complete your Video KYC';
    } else if (status == 'PENDING') {
      this.xplorerVcipMessage = "Thank you! We've received your details and are verifying them. We'll notify you once it's done.";
      this.xplorerVcipTitle = 'Your Video KYC is under review';
    } else if (status == 'REJECTED') {
      this.xplorerVcipMessage = "We couldn't verify your details this time. Please try again with good lighting, a stable internet connection, and your original PAN card.";
      this.xplorerVcipTitle = 'Video KYC unsuccessful';
    }
  }

  getXplorerVcipActionLabel(): string {
    const status = (this.resGetVcipStatus?.vcipStatus || '').toUpperCase();
    if (status === 'NOT_INITIATED' || status === 'INITIATED' || status == 'IN_PROGRESS' || !status) {
      return 'Start Video KYC';
    } else if (status === 'REJECTED') {
      return 'Retry Video KYC';
    }
    return 'Okay';
  }

  onVcipModalAction() {
    this.modalReference.close();
    if (this.resGetVcipStatus?.vcipStatus != 'PENDING') {
      this.initiateVcip();
    }
  }

  initiateVcip() {
    this.updateProfileService.getVCIPRedirectionURL().subscribe((resp => {
      this.showLoader = false;
      var vcipResponse = JSON.parse(JSON.stringify(resp.body));
      let vcipUrl = vcipResponse.mobileAutologinUrl;
      window.open(vcipUrl, '_blank');
    }), error => {
      this.showLoader = false;
      this.toast.error(JSON.stringify(error.error.message));
    });
  }
}
